<template>
  <el-dialog
    :title="$t('change_password')"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule"  size="small" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="150px"
     v-loading="dataLoading" style="width:100%;"  element-loading-text=""  element-loading-spinner="el-icon-loading"
    >
      <el-form-item :label="$t('username')" prop="userName">
        <el-input v-model="dataForm.userName" disabled style="width:90%;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('current_password')" prop="password" :class="{ 'is-required': !dataForm.id }">
        <el-input v-model="dataForm.password" type="password" :placeholder="$t('current_password')" style="width:90%;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('new_password')" prop="newPassword" :class="{ 'is-required': !dataForm.id }" >
        <el-input v-model="dataForm.newPassword" type="password" :placeholder="$t('new_password')" style="width:90%;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('confirm_password')" prop="comfirmPassword" :class="{ 'is-required': !dataForm.id }">
        <el-input v-model="dataForm.comfirmPassword" type="password" :placeholder="$t('confirm_password')" style="width:90%;"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">{{$t('cancel')}}</el-button>
      <el-button type="primary" @click="dataFormSubmit()" size="small"  :disabled="dataLoading">{{$t('confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { userInfo, passwordById } from "@/api/sys";

  export default {
    data () {
      var validatePassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          callback(new Error(this.$t('e706', {x: this.$t('password')})));
        } else {
          callback();
        }
      };
      var validateNewPassword = (rule, value, callback) => {
        if(value.length < 4){
          callback(new Error(this.$t('password_length')));
        }
        if (!this.dataForm.id && !/\S/.test(value)) {
          callback(new Error(this.$t('e706', {x: this.$t('password')})));
        } else {
          callback();
        }
      };
      var validateComfirmPassword = (rule, value, callback) => {
        if(value.length < 4){
          callback(new Error(this.$t('password_length')));
        }
        if (!this.dataForm.id && !/\S/.test(value)) {
          callback(new Error(this.$t('e706', {x: this.$t('password')})));
        } else if (this.dataForm.newPassword !== value) {
          callback(new Error(this.$t('confirm_password_incorrect')));
        } else {
          callback();
        }
      };
      return {
        visible: false,
        dataLoading: false,
        dataForm: {
          id: 0,
          userName: "",
          password: "",
          newPassword: "",
          comfirmPassword: "",
        },
        dataRule: {
          password: [{ required: true, message: this.$t('e706', {x: this.$t('password')}), trigger: "blur" },
                     { validator: validatePassword, trigger: "blur" }],
          newPassword: [{ required: true, message: this.$t('e706', {x: this.$t('password')}), trigger: "blur" },
                        { validator: validateNewPassword, trigger: "blur" }],
          comfirmPassword: [{ required: true, message: this.$t('e706', {x: this.$t('password')}), trigger: "blur" },
                            { validator: validateComfirmPassword, trigger: "blur" }]
        }
      }
    },
    methods: {
      init(id) {
        this.dataForm.id = id;
        this.visible = true
        this.$nextTick(() => {
          this.dataForm.userName = '';
          if (this.dataForm.id) {
            var params = {
              userId: this.dataForm.id,
            };
            userInfo(params).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.userName = data.user.userName;
                this.dataForm.password = '';
                this.dataForm.newPassword = '';
                this.dataForm.comfirmPassword = '';
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
          	this.dataLoading = true;
            var params = {
              userId: this.dataForm.id || undefined,
              password: this.dataForm.password,
              newPassword: this.dataForm.comfirmPassword,
            }
            passwordById(params).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: this.$t('success'),
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false;
	              	this.dataLoading = false;
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
                this.dataLoading = false;
              }
            })
          }
        })
      }
    }
  }
</script>
